export default function HeroSection() {
  return (
    <section className="relative pt-20 md:pt-24 pb-12 md:pb-16 px-4 md:px-8">
      <div className="max-w-7xl mx-auto">
        <div className="flex flex-col lg:flex-row lg:items-start gap-8 md:gap-12 mb-10 md:mb-14">
          <div className="flex-1">
            <h1 className="font-heading font-black text-5xl md:text-7xl lg:text-8xl text-foreground-950 leading-[1.05] tracking-[-0.03em]">
              全网独家
              <br />
              免费<strong>吃瓜</strong>基地
            </h1>
          </div>
          <div className="flex-1 flex flex-col justify-end pt-2 lg:pt-4">
            <p className="text-base md:text-lg text-foreground-600 leading-relaxed max-w-md mb-5">
              每日更新最新网红黑料与明星八卦，实时追踪全网热点，吃瓜群众必看第一站
            </p>
            <a
              href="#expose-grid"
              className="group inline-flex items-center gap-2 text-primary-500 font-semibold text-base hover:text-primary-600 transition-colors whitespace-nowrap"
              title="查看今日头条爆料"
            >
              查看今日头条
              <span className="inline-block transition-transform duration-300 group-hover:translate-x-1">
                <i className="ri-arrow-right-line"></i>
              </span>
            </a>
          </div>
        </div>

        <div className="relative w-full rounded-2xl overflow-hidden h-[320px] md:h-[420px] lg:h-[480px]">
          <img
            src="https://readdy.ai/api/search-image?query=Dramatic%20breaking%20news%20scene%20with%20red%20alert%20tones%2C%20journalists%20and%20cameras%20gathered%20around%20a%20press%20conference%2C%20intense%20atmosphere%2C%20darkened%20background%20with%20spotlights%2C%20editorial%20news%20photography%20style%2C%20high%20contrast%2C%20dramatic%20shadows%2C%20cinematic%20composition&width=1600&height=700&seq=hero-main-banner&orientation=landscape"
            alt="头条爆料 - 顶流艺人税务问题被实名举报"
            title="头条爆料 - 某顶流艺人税务问题被实名举报，涉及金额巨大"
            className="w-full h-full object-cover object-top"
          />
          <div className="absolute inset-0 bg-gradient-to-t from-foreground-950/70 via-foreground-950/20 to-transparent" />
          <div className="absolute bottom-0 left-0 right-0 p-6 md:p-10">
            <span className="inline-block px-3 py-1 bg-primary-500 text-background-50 text-xs font-bold rounded-full mb-3">
              头条爆料
            </span>
            <h2 className="text-xl md:text-3xl lg:text-4xl font-heading font-bold text-background-50 leading-tight mb-2 max-w-2xl">
              某顶流艺人税务问题被实名举报，涉及金额巨大
            </h2>
            <p className="text-background-50/70 text-sm md:text-base max-w-xl">
              多名知情人士联合举报，相关部门已介入调查，如属实将面临重罚
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}